module.exports = "/_next/static/images/AiDrivenCustomer@2x-c74b3fccac008a6d06047e6d1038e649.webp";